import React from 'react';
import { Box, Card, CardContent, Typography, Stack, Skeleton } from '@mui/material';
import { People as PeopleIcon, CheckCircle as CheckCircleIcon, PersonAdd as PersonAddIcon } from '@mui/icons-material';

interface InfoCardsProps {
  total: number;
  activos: number;
  nuevosEsteMes: number;
  loading?: boolean;
}

const InfoCards: React.FC<InfoCardsProps> = ({ total, activos, nuevosEsteMes, loading = false }) => {
  const CardItem = ({ label, value, icon: Icon, iconColor }: { label: string; value: number; icon: any; iconColor: string }) => (
    <Card
      sx={{
        flex: 1,
        minWidth: '200px',
        backgroundColor: 'white',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        borderTop: '4px solid #a0588e',
      }}
    >
      <CardContent sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', minWidth: '48px' }}>
          <Icon sx={{ fontSize: '40px', color: iconColor }} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              fontSize: '11px',
              fontWeight: 600,
              color: '#999',
              fontFamily: 'Poppins, sans-serif',
              textTransform: 'capitalize',
              letterSpacing: '0.3px',
              mb: 0.5,
            }}
          >
            {label}
          </Typography>
          {loading ? (
            <Skeleton variant="text" width="60%" />
          ) : (
            <Typography
              sx={{
                fontSize: '28px',
                fontWeight: 'bold',
                color: '#a0588e',
                fontFamily: 'Poppins, sans-serif',
              }}
            >
              {value}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <CardItem label="Total clientes" value={total} icon={PeopleIcon} iconColor="#a0588e" />
        <CardItem label="Activos" value={activos} icon={CheckCircleIcon} iconColor="#4caf50" />
        <CardItem label="Nuevos este mes" value={nuevosEsteMes} icon={PersonAddIcon} iconColor="#2196f3" />
      </Stack>
    </Box>
  );
};

export default InfoCards;
